import React, { useEffect, useState } from 'react';
import "../ListView/Style.css";
import Layout from '../../Components/Layout/Layout';
import CalendarFilters from '../../Components/CalendarFilters/Index';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import location from "../../Assets/location-red.svg";
import participants from "../../Assets/participants-red.svg";
import showhideline from "../../Assets/showhide-line.svg";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import EastIcon from '@mui/icons-material/East';
import { APIUrlEICI, APIUrlToken } from '../../Utils/Utils';
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import Loader from '../../Components/Loader/Loader';
import * as XLSX from 'xlsx';
import CalenderModals from '../../Components/Modals/Index';
const ListView = () => {
  const [selectedFilters, setSelectedFilters] = React.useState({
    years: [],
    months: [],
    associateList: [],
    categoriesList: [],
    teamList: []
  })
  const [associateList, setAssociateList] = useState()
  const [commingFilters, setComingFilters] = React.useState({
    years: [],
    months: [],
    associateList: [],
    categoriesList: [],
    teamList: []
  });
  const [allcommingFilters, setAllComingFilters] = React.useState({
    years: [],
    months: [],
    associateList: [],
    categoriesList: [],
    teamList: []
  });

  const [loading, setLoading] = React.useState(false);
  const [changeLocation, setChangeLocation] = useState(false);
  const [changeParticipants, setChangeParticipants] = useState(false);

  const handleLocation = () => {
    setChangeLocation(prev => !prev);
    // setChangeParticipants(false);

  }

  const handleParticipants = () => {
    setChangeParticipants(prev => !prev);
    // setChangeLocation(false);
  }


  const [events, setEvents] = useState([]);
  const [visibleEvents, setVisibleEvents] = useState({});

  const [expandedEvents, setExpandedEvents] = React.useState();
  const [dropdownOpen, setDropdownOpen] = React.useState({});
  const [dropdownOpenLocation, setDropdownOpenLocation] = React.useState({});
  const [dropdownOpenParticipants, setDropdownOpenParticipants] = React.useState({});

  const downloadExcel = (data) => {
    if (!data || typeof data !== "object") {
      console.error("Expected an object with arrays of events.");
      return;
    }
    const flatData = Object.values(data).flat();
    if (!Array.isArray(flatData)) {
      console.error("Failed to flatten data:", flatData);
      return;
    }
    if (flatData.length === 0) {
      console.error("No events to download.");
      return;
    }
    const MAX_CHAR_LIMIT = 32767;
    const processedData = flatData?.sort((a, b) => {
      const dateA = new Date(a.start_datetime);
      const dateB = new Date(b.start_datetime);
      if (dateB - dateA !== 0) return dateB - dateA;

      const joA = a.primary_attendees
        ? a.primary_attendees.map(attendee => attendee.attendee_name || "").join(", ")
        : "";
      const joB = b.primary_attendees
        ? b.primary_attendees.map(attendee => attendee.attendee_name || "").join(", ") : "";

      return joA.localeCompare(joB);
    }).map(event => ({
      Subject: event.subject || "",
      Categories: Array.isArray(event.categories) ? event.categories.join(", ") : "",
      "Start Datetime": moment(event.start_datetime).format("DD-MM-YYYY h:mm a") || "",
      "End Datetime": moment(event.end_datetime).format("DD-MM-YYYY h:mm a") || "",
      Location: event.locations
        ? event.locations.map(location => location.displayName || "").join(", ")
        : "",
      "JO Team": selectedFilters?.teamList?.length ? selectedFilters?.teamList?.map(i => i)?.join(", ") : "",
      "Jo Associate": event.primary_attendees
        ? event.primary_attendees.map(attendee => attendee.attendee_name || "").join(", ")
        : "",
      Participants: event.other_attendees
        ? event.other_attendees?.filter(item => item?.attendee_name !== "JobsOhio Engagement Calendar").map(attendee => attendee.attendee_name || "").join(", ")
        : "",
      //if selectedFilters?.teamList has value then show jo teams option
    }));
    const sanitizedData = processedData?.map(row => {
      const sanitizedRow = { ...row };
      for (const key in sanitizedRow) {
        if (typeof sanitizedRow[key] === "string") {
          if (sanitizedRow[key].length > MAX_CHAR_LIMIT) {
            sanitizedRow[key] =
              sanitizedRow[key].substring(0, MAX_CHAR_LIMIT - 20) + "... [truncated]";
          }
          sanitizedRow[key] = sanitizedRow[key].replace(/{|}|"/g, "").trim();
        }
      }
      return sanitizedRow;
    });
    const worksheet = XLSX.utils.json_to_sheet(sanitizedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Events");
    XLSX.writeFile(workbook, "Events.xlsx");
  };



  const handleMoreClick = (eventId) => {
    setDropdownOpen((prevState) => {
      const newState = { ...prevState };
      Object.keys(newState)?.forEach((key) => {
        if (key !== eventId) {
          newState[key] = false;
        }
      });
      newState[eventId] = !newState[eventId];
      return newState;
    });
  };

  const handleMoreClickLocation = (eventId) => {
    setDropdownOpenLocation((prevState) => {
      const newState = { ...prevState };
      Object.keys(newState)?.forEach((key) => {
        if (key !== eventId) {
          newState[key] = false;
        }
      });
      newState[eventId] = !newState[eventId];
      return newState;
    });
  };

  const handleMoreClickParticipants = (eventId) => {
    setDropdownOpenParticipants((prevState) => {
      const newState = { ...prevState };
      Object.keys(newState)?.forEach((key) => {
        if (key !== eventId) {
          newState[key] = false;
        }
      });
      newState[eventId] = !newState[eventId];
      return newState;
    });
  };


  const toggleEvent = (eventName) => {
    setExpandedEvents((prev) => ({
      ...prev,
      [eventName]: !prev[eventName],
    }));
  };
  const showMoreEvents = (category) => {
    setVisibleEvents((prev) => ({
      ...prev,
      [category]: (prev[category] || 10) + 10,
    }));
  };

  function generateRandomHexCode() {
    const r = Math.floor(Math.random() * 56) + 200;
    const g = Math.floor(Math.random() * 56) + 200;
    const b = Math.floor(Math.random() * 56) + 200;
    const a = 1;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }
  // Get Calendar data 
  const getEventsList = () => {
    setLoading(true)
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "Authorization": APIUrlToken()
      },
      url: `${APIUrlEICI()}/eici_category`,
    };
    axios(option)
      .then((e) => {
        setLoading(false)
        const data = e?.data
        setEvents(data);
      })
      .catch(() => { });
  };
  React.useEffect(() => {
    getEventsList();
  }, []);
  useEffect(() => {
    if (events) {
      setExpandedEvents(() =>
        Object.keys(events).reduce((acc, key) => ({ ...acc, [key]: true }), {}))
    }
  }, [events])
  // Get Filter Data 
  const getCalendarFilters = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "Authorization": `${APIUrlToken()}`
      },
      url: `${APIUrlEICI()}/eici_filter_list`,
    };
    axios(option)
      .then((e) => {
        const data = e?.data;
        setComingFilters(data);
        setAllComingFilters(data)
        const associate = e?.data?.associateList?.map(item => ({
          name: item,
          bgcolor: generateRandomHexCode()
        }))
        setAssociateList(associate)
      })
      .catch(() => { });
  };
  React.useEffect(() => {
    getCalendarFilters();
  }, []);
  // Reset Button 
  const handleClearFilters = () => {
    setLoading(true);
    getCalendarFilters();
    setSelectedFilters({
      years: [],
      months: [],
      associateList: [],
      categoriesList: [],
      teamList: []
    });
    getEventsList()
  };
  // Apply Filter Api 
  const handleApplyFilter = (e) => {
    setLoading(true);
    const data = {};
    data.year = selectedFilters?.years;
    data.month = selectedFilters?.months;
    data.associate = selectedFilters?.associateList;
    data.category = selectedFilters?.categoriesList;
    data.teams = selectedFilters?.teamList;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "Authorization": `${APIUrlToken()}`
      },
      url: `${APIUrlEICI()}/eici_apply_list_filter`,
      data: JSON.stringify(data),
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = e?.data
        setEvents(data);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getDateTime = (start, end) => {
    const a = new Date(start);
    const b = new Date(end);
    if (a?.getDate() === b?.getDate() && a?.getMonth() === b?.getMonth() && a?.getFullYear() === b?.getFullYear()) {
      return (
        <>
          {moment(start).format('MM/DD/YYYY h:mm A')}
          <EastIcon style={{ marginLeft: '5px', marginRight: '5px', height: '15px', width: '15px' }} />
          {moment(end).format('h:mm A')}
        </>
      );
    } else {
      return (
        <>
          {moment(start).format('MM/DD/YYYY h:mm A')}
          <EastIcon style={{ marginLeft: '5px', marginRight: '5px', height: '15px', width: '15px' }} />
          {moment(end).format('MM/DD/YYYY h:mm A')}
        </>
      );
    }
  };
  React.useEffect(() => {
    const handleClick = (e) => {
      if (
        e.target.closest(".main-drop-cont") ||
        e.target.closest(".inner-list-dropdown") ||
        e.target.closest(".participants-dropdown")
      ) {
        return;
      }
      setDropdownOpen({});
      setDropdownOpenLocation((prev) => {
        const updated = { ...prev };
        Object.keys(updated).forEach((key) => (updated[key] = false));
        return updated;
      });
      setDropdownOpenParticipants((prev) => {
        const updated = { ...prev };
        Object.keys(updated).forEach((key) => (updated[key] = false));
        return updated;
      });
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const handleEventModal = (event) => {
    setSelectedEvent(event);  // Store the clicked event
    setModalOpen(true);       // Open the modal
  };
  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedEvent(null);
  };
  const teamsFilter = [
    { "name": "Ian Andrew", "department": "Business Development" },
    { "name": "Alina Harastasanu", "department": "Business Development" },
    { "name": "Justin Kocher", "department": "Business Development" },
    { "name": "Ben Park", "department": "Business Development" },
    { "name": "Charlie Rowell", "department": "Business Development" },
    { "name": "Jordan Tyler", "department": "Business Development" },
    { "name": "Darnita Bradley", "department": "Government Affairs" },
    { "name": "Andrew Cooper", "department": "Government Affairs" },
    { "name": "Jessica Moline", "department": "Government Affairs" },
    { "name": "Lenee Pezzano", "department": "Government Affairs" },
    { "name": "Chris Abrams", "department": "Sector" },
    { "name": "Tyler Allchin", "department": "Sector" },
    { "name": "Karthik Avadhanula", "department": "Sector" },
    { "name": "Ryan Blackburn", "department": "Sector" },
    { "name": "Dave Brewster", "department": "Sector" },
    { "name": "Jonathan Bridges", "department": "Sector" },
    { "name": "Kevin Chambers", "department": "Sector" },
    { "name": "Matt Cybulski", "department": "Sector" },
    { "name": "Tim Derickson", "department": "Sector" },
    { "name": "Michael Dustman", "department": "Sector" },
    { "name": "Josh Hoffman", "department": "Sector" },
    { "name": "Glenn Richardson", "department": "Sector" },
    { "name": "Ron Rock", "department": "Sector" },
    { "name": "Meg Ryan", "department": "Sector" }
  ];

  useEffect(() => {
    if (selectedFilters?.teamList?.length) {
      const filteredAssociate = teamsFilter?.filter(i => selectedFilters?.teamList?.includes(i?.department))?.map(i => i?.name)
      setComingFilters({ ...commingFilters, associateList: filteredAssociate })
      setSelectedFilters({ ...selectedFilters, associateList: [] })
    } else {
      setComingFilters({ ...commingFilters, associateList: allcommingFilters?.associateList })
    }
  }, [selectedFilters?.teamList])
  return (
    <Layout>
      {loading ? <Loader /> : null}
      <CalendarFilters selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} handleApplyFilter={handleApplyFilter} handleClearFilters={handleClearFilters} commingFilters={commingFilters} setComingFilters={setComingFilters} downloadExcel={downloadExcel} events={events} />
      <div className='show-hide-main'>
        <p>Show/Hide</p>
        <img src={showhideline} alt="Show/Hide line" />
        <div className='location-participants-events-main'>
          <div
            className={changeLocation ? 'location-events-background' : 'location-participants-events-inner'}
            onClick={handleLocation}
          >
            <img src={location} alt="Location" />
            <p className='location-participants-events'>Location</p>
          </div>
          <div
            className={changeParticipants ? 'participants-events-background' : 'location-participants-events-inner'}
            onClick={handleParticipants}
          >
            <img src={participants} alt="Participants" />
            <p className='location-participants-events'>Participants</p>
          </div>
        </div>
      </div>
      {Object.keys(events)?.map((item) => (
        <div key={item}>
          {
            events[item]?.length ?
              <div className='outer-event-head' key={item}>
                <div className='event-head'>
                  <div
                    className='location-participants-events-inner'
                    onClick={() => toggleEvent(item)}
                  >
                    <p>{expandedEvents[item] ? <ArrowDropDownIcon /> : <ArrowRightIcon />}</p>
                    <button className='event-button'>{item}</button>
                  </div>
                </div>
                {expandedEvents[item] &&
                  events[item]?.filter(event =>
                    event?.other_attendees?.some(attendee => attendee?.attendee_name !== "JobsOhio Engagement Calendar")
                  ).slice(0, visibleEvents[item] || 10).map((event, index) => (
                    <div key={index} className='events-text'>
                      <div className='events-text-inner'>
                        <p><DescriptionOutlinedIcon className='event-icon' /></p>
                        <p className='date-right-aligned'>
                          {/* {getDateTime(event?.start_datetime, event?.end_datetime)} */}
                          {moment(event?.start_datetime).format("MM/DD/YYYY")}

                        </p> |
                        <div className='right-align-text-event'>
                          {event?.primary_attendees?.length ? (
                            <>
                              {event?.primary_attendees?.slice(0, 1).map((attendee, idx) => (
                                <button
                                  key={idx}
                                  className='associate_color'
                                  style={{
                                    backgroundColor: `${associateList?.find(
                                      (i) => i?.name === attendee?.attendee_name
                                    )?.bgcolor}`,
                                  }}
                                >
                                  {attendee?.attendee_name}
                                </button>
                              ))}

                              {event?.primary_attendees?.length > 1 && (
                                <div className="main-drop-cont">
                                  <p
                                    className="see-more-button"
                                    onClick={() => handleMoreClick(event.event_id)}
                                  >
                                    +{event?.primary_attendees?.length - 1} More
                                  </p>
                                  {dropdownOpen[event.event_id] && (
                                    <div className="inner-list-dropdown">
                                      {event?.primary_attendees?.slice(1).map((attendee, idx) => (
                                        <button
                                          key={idx}
                                          className="associate_color"
                                          style={{
                                            backgroundColor: `${associateList?.find(
                                              (i) => i?.name === attendee?.attendee_name
                                            )?.bgcolor}`,
                                          }}
                                        >
                                          {attendee?.attendee_name}
                                        </button>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              )}


                            </>
                          ) : null}

                        </div> |
                        <p className='left-textevent' onClick={() => handleEventModal(event)}>{event.subject}</p>
                      </div>
                      <div className='right-align-text-event-main'>
                        {/* toggle on the basis of Location and Participants Button */}
                        {/* {changeLocation || changeParticipants ? */}


                        {event?.primary_attendees?.length ? (
                          <>
                            {changeLocation && (
                              <>
                                {event?.locations?.length ?
                                  <p className="location-data">
                                    {event?.locations?.slice(0, 1).map((location, idx) => (
                                      <span key={idx}>{location?.displayName}</span>
                                    ))}
                                  </p>
                                  : null}
                                {event?.locations?.length > 1 && (
                                  <div className="main-drop-cont">
                                    <p className="see-more-button" onClick={() => handleMoreClickLocation(event.event_id)}>
                                      +{event?.locations?.length - 1} More
                                    </p>
                                    {dropdownOpenLocation[event.event_id] && (
                                      <div className="inner-list-dropdown">
                                        {event?.locations?.slice(1).map((location, idx) => (
                                          <span key={idx}>{location?.displayName}</span>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </>
                            )}
                            {
                              changeParticipants && (
                                <>
                                  {event?.other_attendees?.filter(item => item?.attendee_name !== "JobsOhio Engagement Calendar")?.length ? (
                                    <>
                                      {event?.other_attendees?.filter(item => item?.attendee_name !== "JobsOhio Engagement Calendar")?.slice(0, 1).map((attendee, idx) => (
                                        <button key={idx} className='participants-data'>
                                          {attendee?.attendee_name}
                                        </button>
                                      ))}
                                      {event?.other_attendees?.filter(item => item?.attendee_name !== "JobsOhio Engagement Calendar")?.length > 1 && (
                                        <div className="main-drop-cont">
                                          <p className="see-more-button" onClick={() => handleMoreClickParticipants(event.event_id)}>
                                            +{event?.other_attendees?.filter(item => item?.attendee_name !== "JobsOhio Engagement Calendar")?.length - 1} More
                                          </p>
                                          {dropdownOpenParticipants[event.event_id] && (
                                            <div className="inner-list-dropdown">
                                              {event?.other_attendees?.filter(item => item?.attendee_name !== "JobsOhio Engagement Calendar")?.slice(1).map((attendee, idx) => (
                                                <span key={idx} >
                                                  {attendee?.attendee_name}
                                                </span>
                                              ))}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </>
                                  ) : null}
                                </>
                              )}
                          </>
                        ) : null}
                      </div>
                    </div>
                  ))}
                {expandedEvents[item] &&
                  events[item].length > (visibleEvents[item] || 10) && (
                    <button
                      className="show-more-button"
                      onClick={() => showMoreEvents(item)}
                    >
                      Load More...
                    </button>
                  )}
              </div> : null
          }
        </div>
      ))}
      <CalenderModals
        open={modalOpen}
        onClose={handleModalClose}
        event={selectedEvent}
      />
    </Layout>
  );
};
export default ListView;



// const downloadExcel = (data) => {
//   if (!data || typeof data !== "object") {
//     console.error("Expected an object with arrays of events.");
//     return;
//   }
//   const flatData = Object.values(data).flat();
//   if (!Array.isArray(flatData)) {
//     console.error("Failed to flatten data:", flatData);
//     return;
//   }
//   if (flatData.length === 0) {
//     console.error("No events to download.");
//     return;
//   }
//   const MAX_CHAR_LIMIT = 32767;
//   const processedData = flatData.map(event => {
//     const transformedEvent = { ...event };
//     for (const key in transformedEvent) {
//       if (Array.isArray(transformedEvent[key])) {
//         transformedEvent[key] = transformedEvent[key]
//           .map(item => (typeof item === "object" ? JSON.stringify(item) : item))
//           .join(", ");
//       } else if (typeof transformedEvent[key] === "object" && transformedEvent[key] !== null) {
//         transformedEvent[key] = JSON.stringify(transformedEvent[key]);
//       }
//       if (typeof transformedEvent[key] === "string" && transformedEvent[key].length > MAX_CHAR_LIMIT) {
//         transformedEvent[key] = transformedEvent[key].substring(0, MAX_CHAR_LIMIT - 20) + "... [truncated]";
//       }
//     }
//     return transformedEvent;
//   });
//   const worksheet = XLSX.utils.json_to_sheet(processedData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Events");
//   XLSX.writeFile(workbook, "Events.xlsx");
// };
